import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, RefreshCw } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-white border-b border-gray-100" data-id="element-114">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="max-w-4xl mx-auto bg-[#F0FDF4] rounded-3xl p-8 md:p-12 border border-[#DCFCE7] text-center" data-id="element-116">
          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm text-[#10B981]" data-id="element-117">
            <ShieldCheck size={48} strokeWidth={1.5} data-id="element-118" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-[#064E3B] mb-4" data-id="element-119">
            Garantía de Satisfacción 21 dias
          </h2>

          <p className="text-[#4B5563] mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-120">
            Garantizamos la efectividad de nuestro sistema de 21 días. Si ejecutas el paso a paso —desde el detox hepático hasta el sellado intestinal—, los resultados en tu energía y metabolismo son la consecuencia matemática de aplicar el protocolo correcto en el orden adecuado.
          </p>

          <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm font-medium text-[#0D6B4F]" data-id="element-121">
            <div className="flex items-center" data-id="element-122">
              <Lock size={18} className="mr-2" data-id="element-123" />
              <span data-id="element-124">Pago Seguro</span>
            </div>
            <div className="flex items-center" data-id="element-125">
              <RefreshCw size={18} className="mr-2" data-id="element-126" />
              <span data-id="element-127">Resultados notables</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}